import React, { memo, useCallback, useState } from "react"
import { IconButton, makeStyles, Typography } from "@material-ui/core"
import { LocalizedStrict } from "shared/Modules/Localization/Components/Localized"
import { Section } from "shared/Components/Skeleton/Section"
import Card from "shared/Components/Card/Card"
import { useSelector } from "react-redux"
import { selectUserCanteenId } from "shared/Modules/User/userSelectors"
import { ActionSheetButtonItem } from "shared/Components/Dialog/Options/ActionSheetModalContent"
import OptionsDialog from "shared/Components/Dialog/Options/OptionsDialog"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCoffee } from "@fortawesome/pro-light-svg-icons"

const useStyles = makeStyles((theme) => ({
    iconButton: {
        padding: '40px 16px 16px',
        width: "100%",
        backgroundColor: "#F3E8FF",
        borderRadius: "12px",

        "& .MuiIconButton-label": {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
        },

        "&:hover": {
            backgroundColor: "#F3E8FF !important",
        }
    },
    planMeetingText: {
        fontWeight: 500,
        fontSize: "20px",
        lineHeight: 1.6,
        letterSpacing: "0.15px",
        color: "#581C87",
        paddingTop: "22px"
    },
    productCardContent: {
        padding: "0.5rem 0",
    },
    cardTitleWrap: {
        flexDirection: "column",
        gap: "0.25rem",
    },
    description: {
        clear: "both",
        margin: 0,
        overflow: "hidden",
        whiteSpace: "nowrap",
        width: "100%",
    },
    icon: {
        fontSize: '90px'
    }
}))

enum SelectedDialogChoice {
    OrderMeeting = 'orderMeeting',
    BookResource = 'bookResource'
}

interface IProps {
    readonly showCateringModule: boolean
    readonly resourceBookingEnabled: boolean
    readonly goToMeetingPlanning: (userCanteenId: number) => void
    readonly goToBookResource: () => void
}

const MeetingPlanningSection = ({ showCateringModule, resourceBookingEnabled, goToMeetingPlanning, goToBookResource }: IProps) => {
    const classes = useStyles()
    const userCanteenId = useSelector(selectUserCanteenId)
    const [isOpen, setIsOpen] = useState(false)

    const navigateToMeetingPlanning = useCallback((choice: SelectedDialogChoice) => {
        if (userCanteenId && choice === SelectedDialogChoice.OrderMeeting) {
            goToMeetingPlanning(userCanteenId)
        }
        if (choice === SelectedDialogChoice.BookResource) {
            goToBookResource()
        }
    }, [userCanteenId])

    const orderMeeting = () => navigateToMeetingPlanning(SelectedDialogChoice.OrderMeeting)
    const bookResource = () => navigateToMeetingPlanning(SelectedDialogChoice.BookResource)

    const openDialog = useCallback(() => setIsOpen(true), [setIsOpen])
    const closeDialog = useCallback(() => setIsOpen(false), [setIsOpen])

    return (
        <>
            <LocalizedStrict id="home-book-meeting-title" attrs={{ title: true }}>
                <Section title="Book meeting">
                    <Card height="100%" width="100%" boxShadow="none" borderRadius=".25rem" onClick={openDialog}>
                        <IconButton className={classes.iconButton}>
                            <FontAwesomeIcon icon={faCoffee} className={classes.icon} color="#581C87" />

                            <LocalizedStrict id="home-plan-meeting">
                                <Typography variant="body2" className={classes.planMeetingText}>Planlæg et møde</Typography>
                            </LocalizedStrict>
                        </IconButton>
                    </Card>
                </Section>
            </LocalizedStrict>
            <OptionsDialog
                open={isOpen}
                onClose={closeDialog}
            >
                {showCateringModule && <LocalizedStrict id="order-meeting-service">
                    <ActionSheetButtonItem onClick={orderMeeting}>
                        Bestil mødeforplejning
                    </ActionSheetButtonItem>
                </LocalizedStrict>}
                {resourceBookingEnabled && <LocalizedStrict id="book-resources">
                    <ActionSheetButtonItem onClick={bookResource}>
                        Book ressourcer
                    </ActionSheetButtonItem>
                </LocalizedStrict>}
            </OptionsDialog>
        </>
    )
}

export default memo(MeetingPlanningSection)
